import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'viso-offline-modal',
  templateUrl: './offline-modal.component.html',
  styleUrls: ['./offline-modal.component.scss'],
  standalone: false,
})
export class OfflineModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
